import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import DeviationsSection from './components/DeviationsSection';
import VisualDefectsSection from './components/VisualDefectsSection';
import ProgressComparisonTabs from './components/ProgressComparisonTabs';
import DetectionsSection from './components/DetectionsSection';

interface AnalyticsTabsProps {
  analytics: any;
  scans: any;
  selectedScan: string;
  analyticsCreatedAt?: string;
  selectedScanData?: any;
}

const tabLabels = [
  'Deviations',
  'Visual Defects',
  'Progress',
  'Detections',
];

const AnalyticsTabs: React.FC<AnalyticsTabsProps> = ({
  analytics,
  scans,
  selectedScan,
  analyticsCreatedAt,
  selectedScanData,
}) => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 3 }}
      >
        {tabLabels.map((label, idx) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>
      <Box sx={{ mt: 1 }}>
        {tab === 0 && <DeviationsSection deviations={analytics.deviations} />}
        {tab === 1 && <VisualDefectsSection visualDefects={analytics.visual_defects} />}
        {tab === 2 && (
          <ProgressComparisonTabs
            progress={analytics.progress}
            scans={scans}
            selectedScan={selectedScan}
            analyticsCreatedAt={analyticsCreatedAt}
            selectedScanData={selectedScanData}
          />
        )}
        {tab === 3 && (
          <DetectionsSection detections={analytics.detections.map(({ category, ...rest }: any) => ({ label: category, ...rest }))} />
        )}
      </Box>
    </Box>
  );
};

export default AnalyticsTabs;
